import React, { createContext, useEffect } from "react";
import "./App.css";
import Home from "./components/home/Home";
import { ToastContainer } from "react-toastify";
import Login from "./components/login/Login";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import DashboardAccountant from "./components/accountant/DashboardAccountant";
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

export const RoleContext = createContext();

const App = () => {
  const role = Cookies.get("role");
  const token = Cookies.get("token");
  const auth = token ? true : false;

  const [isAuthenticated, setIsAuthenticated] = React.useState(auth);

  useEffect(() => {
    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decodedToken.exp < currentTime) {
          Cookies.remove("role");
          Cookies.remove("token");
          setIsAuthenticated(false);
          toast.error("Tizimga kirish muddati tugadi!");
        }
      } catch (error) {
        Cookies.remove("role");
        Cookies.remove("token");
        setIsAuthenticated(false);
        toast.error("Tizimga kirish muddati tugadi!");
      }
    }

    const handleAuthError = () => {
      Cookies.remove("role");
      Cookies.remove("token");
      setIsAuthenticated(false);
      toast.error(
        "Sizda ushbu amalni bajarish uchun ruxsat yo'q yoki token muddati tugagan. Iltimos qaytadan kiring.",
      );
    };

    window.addEventListener("auth-error", handleAuthError);
    return () => window.removeEventListener("auth-error", handleAuthError);
  }, [token]);

  console.log("token", token);

  return (
    <RoleContext.Provider value={role}>
      <BrowserRouter>
        <ToastContainer />
        {isAuthenticated ? (
          <Routes>
            <Route path="/" element={<Home />} />
            <Route
              path="/dashboard-accountant"
              element={<DashboardAccountant />}
            />
          </Routes>
        ) : (
          <Login setIsAuthenticated={setIsAuthenticated} />
        )}
      </BrowserRouter>
    </RoleContext.Provider>
  );
};

export default App;
